import { render, staticRenderFns } from "./auftrag.vue?vue&type=template&id=da5cc8ac&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./auftrag.vue?vue&type=script&lang=js"
export * from "./auftrag.vue?vue&type=script&lang=js"
import style0 from "./auftrag.vue?vue&type=style&index=0&id=da5cc8ac&prod&lang=css"
import style1 from "./auftrag.vue?vue&type=style&index=1&id=da5cc8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5cc8ac",
  null
  
)

export default component.exports